import { DealershipBadgeComponent } from './dealership.badge.component';
import { JobRowExpandComponent }    from '../../app-lite/transaction-center/jobs/transaction-center.job.row.expand.component';

export function DealershipTransactionCenterCtrl (
  $rootScope,
  $scope,
  $state,
  $translate,
  messages,
  messengerApi,
  sessionObjAPI,
  workshopAPI,
  constraints,
  invoiceTypes,
  tableApi,
  transactions
) {

  $scope.company       = sessionObjAPI.company();
  $scope.constraints   = constraints;
  $scope.invoiceTypes  = invoiceTypes;
  $scope.regoLabel     = $scope.company.company_variable_fields.plate_number_name || sessionObjAPI.countrySettings().rego_label;
  $scope.tableCacheKey = 'dealershipTransactionCenter';
  $scope.transactions  = transactions;

  $scope.filtering = tableApi.setFiltersFromCache($scope.tableCacheKey, {
    constrain_by: '*',
    invoice_type: '*',
    post_date   : '*',
    value       : ''
  });

  $scope.tableSettings = {
    broadcast: 'filterTransactions',
    cache    : {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        classes: 'text-left',
        field  : 'job.invoice.post_date',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'globalDate',
      },
      {
        classes: 'text-left',
        field  : 'job.customer.display_name',
        header : {
          text: $translate.instant('CUSTOMER_SPACE.CUSTOMER')
        },
      },
      {
        classes: 'text-left',
        field  : 'job.invoice.invoice_type',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.INVOICE_TYPE')
        },
        pipe: 'invoiceType',
      },
      {
        classes: 'text-left',
        field  : 'job.invoice.invoice_number',
        header : {
          text: $translate.instant('REPORT_SPACE.FIELD.INVOICE_NUMBER')
        },
      },
      {
        classes  : 'text-center',
        component: {
          enabled: true,
          factory: DealershipBadgeComponent,
        },
        field : 'job.invoice.contains_vehicle_sale',
        header: {
          classes: 'text-center',
          text   : $translate.instant('DEALERSHIP_SPACE.CONTAINS_SALE')
        },
      },
      {
        classes  : 'text-center',
        component: {
          enabled: true,
          factory: DealershipBadgeComponent,
        },
        field : 'job.invoice.contains_trade_in',
        header: {
          classes: 'text-center',
          text   : $translate.instant('DEALERSHIP_SPACE.CONTAINS_TRADE_IN')
        },
      },
      {
        classes: 'text-right',
        field  : 'job.invoice.total',
        header : {
          classes: 'text-right',
          text   : $translate.instant('GENERAL_SPACE.FIELD.TOTAL')
        },
        pipe: 'globalCurrency',
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_TRANSACTIONS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 10,
      pageSizes : [ 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/dealership_job_center/count', [
        $scope.filtering.value        || '*',
        $scope.filtering.post_date    || '*',
        $scope.filtering.constrain_by || '*',
        $scope.filtering.invoice_type || '*'
      ])
    },
    rows: {
      expand: {
        bindings: {
          outputs: {
            onEditClick : event => $scope.viewJob(event),
            onLaborClick: event => console.log('Show Labour Items'),
            onSMSClick  : event => $scope.sendSMS(event)
          }
        },
        enabled: true,
        factory: JobRowExpandComponent
      },
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'desc',
      field    : 'invoice.post_date'
    })
  };

  $scope.getTransactions = ( params ) => {
    const fieldSplit = params.field.split('.');

    return workshopAPI.stream('/dealership_job_center', [
      $scope.filtering.value        || '*',
      params.offset,
      params.pageSize,
      $scope.filtering.post_date    || '*',
      $scope.filtering.constrain_by || '*',
      $scope.filtering.invoice_type || '*',
      fieldSplit[fieldSplit.length-1],
      params.direction,
    ]).then(transactions => {
      $scope.transactions = transactions;

      return transactions;
    });
  };

  $scope.refresh = function() {
    $state.reload();
  };

  $scope.onRowDoubleClick = function (event) {
    $state.go('app.dealership.sale', {
      customer_id: event.row.job.invoice.customer_id,
      id         : event.row.job.invoice.id
    });
  };

  $scope.sendSMS = function(row) {
    messengerApi.sms({
      customer_id: row.job.customer.id,
      invoice_id : row.job.invoice.id,
      name       : row.job.customer.display_name,
      send_to    : row.job.customer.mobile
    })
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.MESSAGE_SENT'), 'success');
    });
  };

  $scope.$watch('[filtering.value, filtering.post_date, filtering.constrain_by, filtering.invoice_type]', (newVal, oldVal) => {
    if (newVal !== oldVal) {
      window['filterTransactions']($scope.filtering);
    }
  }, true);
};